import SEO from "@/components/SEO";
import { CTAButton, MoveCare } from "@/components/common/Bits";
import { WindowGrid } from "@/components/motion/Reveal";

export default function NotFound() {
    return (
        <>
            <SEO title="Page Not Found" />
            <section className="relative flex min-h-screen items-center justify-center overflow-hidden bg-brand-blue px-6 text-center text-white grain">
                <div className="pointer-events-none absolute -right-16 -top-10 opacity-10"><WindowGrid size={280} /></div>
                <div className="relative">
                    <p className="font-display text-[22vw] font-bold leading-none text-white/10 sm:text-[180px]">404</p>
                    <h1 className="-mt-6 font-display text-3xl font-semibold sm:text-4xl">
                        <MoveCare text="Looks like this page has MOVEd." />
                    </h1>
                    <p className="mx-auto mt-4 max-w-md text-white/70">The page you’re looking for can’t be found — but we’ll take CARE of getting you back on track.</p>
                    <div className="mt-8 flex justify-center">
                        <CTAButton to="/" variant="light" testid="notfound-home-cta">Back to Home</CTAButton>
                    </div>
                </div>
            </section>
        </>
    );
}
